import { Globe } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function WebsiteManager() {
  return (
    <PlaceholderPage 
      title="Website Manager" 
      description="Easily manage your travel advisor website content, itineraries, and featured destinations."
      icon={<Globe size={48} />} 
    />
  );
}